import { DocumentRetrievalLocationStatus } from "healthex-common/document.retrieval.dtos";
export function hasEligibleRetrievalLocationsForHur(retrieval) {
    if (!retrieval)
        return false;
    return retrieval.locations.some((location) => !location.isExcluded &&
        location.status !== DocumentRetrievalLocationStatus.NEEDS_AUTH &&
        location.status !== DocumentRetrievalLocationStatus.SKIPPED);
}
